import { AuthApi } from '../../../api';
import { ToastStateHandler } from '../../../api/utils/ToastStateHandler';
import { ICallback } from '../../../commonTypes/hook.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { AppError, getUserMessage } from '../../../api/utils/ErrorHandler';

const useHttpPostForgotPassword = () => {
    const { t } = useTranslation('newNotifications');
    const authApi: AuthApi = useContainer(AuthApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (email: string, callback: ICallback) => {
        const { exec, clearCache, abort } = authApi.forgotPassword({
            body: {
                username: email,
            },
            onSuccess: () => {
                toastHandler.push('success', t('auth.forgottenPasswordTitle'), t('auth.forgottenPasswordMessage_Success'));
                clearCache();
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: (err: AppError | string) => {
                const errorMessage = getUserMessage(err);
                toastHandler.push('warn', t('auth.forgottenPasswordTitle'), errorMessage);
            },
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpPostForgotPassword;
